export default __webpack_public_path__ + "static/media/EXAMPLE_DRAWING_THUMBNAIL.4e8b608b.png";